// Form controls a person types into or sets. `contenteditable` covers code
// editors such as CodeMirror; `.input-trigger` and the roles cover registry
// controls drawn as buttons (Select and DropdownInput fields, Checkbox, Switch,
// RadioGroup). Plain buttons and links are deliberately not here: they aren't inputs.
const INPUT = [
  'input',
  'select',
  'textarea',
  '[contenteditable="true"]',
  '.input-trigger',
  '[role="combobox"]',
  '[role="textbox"]',
  '[role="checkbox"]',
  '[role="switch"]',
  '[role="radio"]',
  '[role="spinbutton"]',
  '[role="slider"]',
].join(', ');

const FOOTER_BUTTON = '.dialog-footer-buttons button';

// Matches a selector but can't take focus from a person: disabled controls,
// hidden inputs, and the off-tab-order inputs Radix renders inside Checkbox
// and Switch to carry a form value.
const isFocusTarget = (element: HTMLElement) =>
  !element.matches(':disabled, [type="hidden"], [tabindex="-1"], [aria-hidden="true"]');

const focusFirst = (container: HTMLElement, selector: string) => {
  for (const candidate of container.querySelectorAll<HTMLElement>(selector)) {
    if (!isFocusTarget(candidate)) continue;
    candidate.focus();
    if (document.activeElement === candidate) return true;
  }
  return false;
};

/**
 * Where a Dialog's focus starts: the first input in the dialog, or, with no
 * input, the leftmost footer button. Radix otherwise focuses the header close
 * X, which nobody opens a dialog to press. Pass it as `DialogContent`'s
 * `onOpenAutoFocus`.
 *
 * Radix's own default runs only when neither exists. AlertDialog already starts
 * on Cancel, its leftmost footer button, so it doesn't need this.
 */
export function focusDialogStart(event: Event) {
  const dialog = event.currentTarget ?? event.target;
  if (!(dialog instanceof HTMLElement)) return;
  if (focusFirst(dialog, INPUT) || focusFirst(dialog, FOOTER_BUTTON)) {
    event.preventDefault();
  }
}
